/**
 * Redemption API
 * Handles transaction, order processing, and checkout endpoints
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseAPI } from "./base-api";
export class RedemptionAPI extends BaseAPI {
    /**
     * Push signed transaction to runtime
     */
    pushTransaction(payload, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.post(`${this.env.API_URL}runtime/push-transaction`, payload, { "x-access-token": token });
                return result.data;
            }
            catch (error) {
                console.error("Error pushing transaction:", error);
                throw error;
            }
        });
    }
    /**
     * Process order after successful transaction
     */
    processOrder(payload, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.post(`${this.env.API_URL}orders/process-order`, payload, { "x-access-token": token });
                return result.data;
            }
            catch (error) {
                console.error("Error processing order:", error);
                throw error;
            }
        });
    }
    /**
     * Generate Shopify checkout URL with discount code
     */
    getCheckoutUrl(payload, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.post(`${this.env.API_V1_URL}order/shopify/checkout-url`, payload, { Authorization: `Bearer ${token}` });
                return result.data.url;
            }
            catch (error) {
                console.error("Error getting checkout URL:", error);
                throw error;
            }
        });
    }
    /**
     * Refund task if transaction fails
     */
    refundTask(payload, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.post(`${this.env.API_URL}runtime/refund-task`, payload, {
                    "x-access-token": token,
                });
            }
            catch (error) {
                console.error("Error refunding task:", error);
                throw error;
            }
        });
    }
}
